<script>
    import { onMount } from 'svelte';
    export let propsForForm;
    let username;
    let urlSlug = '';
    let authorized = false;
    let missingUsername = false;
    let isNewlyPublished = false;

    $: urlSlug = urlSlug.replace(/[^0-9a-z]/gi, '-')

    const [postUid, slug, isPublished] = propsForForm;

    async function checkPublishAuth() {
        const data = await fetch('/api/v1/publish/auth');
        return await data.json();
    }

    async function renderUi() {
        // check for username in frontend.
        // if no username found in frontend, check backend.
        const {
            username: _username,
            authorized: _authorized,
        } = await checkPublishAuth();

        // if not authorized show a friendly message asking them to get in touch.
        if (_authorized) {
            authorized = true;
        }

        username = _username

        if (!_username) {
            missingUsername = true;
        }
    }

    async function createUsername() {
        missingUsername = false;
        const body = { method: 'POST', body: JSON.stringify({ username }) }
        const data = await fetch('/api/v1/update-username', body);
        const response = await data.json();

        if (!response.success) {
            usernameError = true;
            missingUsername = true;
        }
    }

    async function publishNote() {
        const response = await fetch('/api/v1/post/publish', {
            method: 'POST',
            body: JSON.stringify({
                postUid,
                slug: slug || urlSlug,
            })
        });

        const {
            success,
        } = await response.json();

        isNewlyPublished = success;
    }
    
    onMount(async() => {
        await renderUi();
    })
</script>

<main>

    {#if missingUsername}
        <form id="new-username-form">
            <input bind:value={username} class="input" type="text" name="user-name" autocomplete="off" placeholder="username" data-required="true" required />
            <button on:click|preventDefault={() => createUsername()} type="submit" form="new-username-form" class="primary-green">
                create username
            </button>
        </form>
    {/if}

    {#if authorized && !missingUsername && !(slug && (isPublished || isNewlyPublished))}
        <form id="new-note-url-form">
            {#if !slug}
                <input bind:value={urlSlug} class="input" type="text" name="slug-name" autocomplete="off" placeholder="url" data-required="true" required />
                <button on:click|preventDefault={() => publishNote()} type="submit" form="new-note-url-form" class="primary-green">
                    create url
                </button>
            {:else if !isPublished}
                <input value={slug} class="input" type="text" name="slug-name" autocomplete="off" placeholder="url" data-required="true" required />
                <button on:click|preventDefault={() => publishNote()} type="submit" form="new-note-url-form" class="primary-green">
                    publish
                </button>
            {/if}
        </form>
    {/if}

    <!--
        authorized && username => create url, egfeeds.com/{username}/{url}
    -->
    {#if !authorized}
        <p>
            Interested in publishing your writing and curated content?
            <br><br>
            Email me at <span style="font-weight:bold">kaustubhardwaj@gmail.com</span>, with your name and 2 quick lines about what brings you here.
            <br><br>
            Why, you ask? I'm personally onboarding any new publishers at the moment,
            because I want to better understand how evergreenfeeds can help, and because
            its important that the quality bar here remains high.
            <br><br>
            Not ready to publish? No problem! Feel free to share as many notes here as you like 😎
        </p>
    {/if}

    {#if username}
        <div>share link:</div>
        <div>https://evergreenfeeds.com/<bold>{username}</bold>/d/{postUid}</div>
    {/if}

    {#if slug || urlSlug}
        <div style="margin-top:20px;">published link:</div>
        <div>https://evergreenfeeds.com/<bold>{username}</bold>/{slug || urlSlug}</div>
    {/if}

</main>